import { Domain, Hooks } from '@3nickels/data-modules';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MAX_OWNER_LABEL_LENGTH = 14;

function truncateOwnerLabel(label: string): string {
  if (label.length <= MAX_OWNER_LABEL_LENGTH) {
    return label;
  }

  return `${label.slice(0, MAX_OWNER_LABEL_LENGTH - 1)}...`;
}

export function useAccountOwnerOptions() {
  const { t } = useTranslation();
  const spouseData = Hooks.useSpouseData();

  return useMemo(
    () => [
      { label: t('Me'), value: 'me' as Domain.Owner },
      {
        label: truncateOwnerLabel(spouseData?.preferredName?.trim() || t('Spouse')),
        value: 'spouse' as Domain.Owner,
      },
    ],
    [spouseData?.preferredName, t]
  );
}
